import { type z } from 'zod';
import { object as __eliadmin_zod_0, string as __eliadmin_zod_1, boolean as __eliadmin_zod_2 } from 'zod';
import { ensureZodDefaults as __eliadmin_zod_defaults } from '@eliadmin/core/src/build/zod-defaults';
__eliadmin_zod_defaults();

import { meetsRequiredPasswordRules } from '@eliadmin/core/src/components/dlz/forms/password-rules';
import { RESET_COPY } from '@eliadmin/core/src/components/dlz/auth/password-reset/password-reset-copy';
import type { FormValidationMessages } from '@eliadmin/core/src/hooks/use-form-validation-messages';

/**
 * Body of the „Nastavte si nové heslo“ step. The password has to meet the rules listed under the
 * field (`PASSWORD_RULES`; the special character is only recommended).
 */
export const resetPasswordSchema = (VM: FormValidationMessages) =>
  __eliadmin_zod_0({
      email: __eliadmin_zod_1().email(VM.EMAIL_INVALID_VALIDATION_MESSAGE()),
      password: __eliadmin_zod_1()
        .min(1, VM.REQUIRED_FIELD_VALIDATION_MESSAGE())
        .refine(meetsRequiredPasswordRules, { message: RESET_COPY.passwordRules }),
      password_confirmation: __eliadmin_zod_1().min(1, VM.REQUIRED_FIELD_VALIDATION_MESSAGE()),
      logout_other_devices: __eliadmin_zod_2(),
    })
    .refine(data => data.password === data.password_confirmation, {
      message: VM.PASSWORD_CONFIRMATION_DONT_MATCH_VALIDATION_MESSAGE(),
      path: ['password_confirmation'],
    });

export type ResetPasswordValues = z.infer<ReturnType<typeof resetPasswordSchema>>;
